<template>
  <TabMenu :tabs="menu" :current="current" />
</template>

<script>
export default {
  props: {
    current: { type: String, default: "" },
  },
  computed: {
    menu() {
      return [
        {
          label: "Training",
          items: [
            {
              label: "Courses",
              action: () => {
                this.goToRoute("admin.courses.index");
              },
            },
            {
              label: "Events",
              action: () => {
                this.goToRoute("admin.events.index");
              },
            },
            {
              label: "Learning Paths",
              action: () => {
                this.goToRoute("admin.learning-paths.index");
              },
            },
            {
              label: "Series",
              action: () => {
                this.goToRoute("admin.series.index");
              },
            },
            {
              label: "Tech Docs",
              action: () => {
                this.goToRoute("admin.documents.index");
              },
            },
          ],
        },
        {
          label: "Orders",
          items: [
            {
              label: "Materials",
              action: () => {
                this.goToRoute("admin.materials.index");
              },
            },
            {
              label: "Orders",
              action: () => {
                this.goToRoute("admin.orders.index");
              },
            },
          ],
        },
        {
          label: "Reports",
          url: this.route("admin.reports.index"),
        },
        {
          label: "Users",
          url: this.route("admin.users.index"),
        },
        {
          label: "Companies",
          url: this.route("admin.companies.index"),
        },
        {
          label: "Media",
          items: [
            {
              label: "Asset Library",
              action: () => {
                this.goToRoute("admin.assets.index");
              },
            },
            {
              label: "Asset Categories",
              action: () => {
                this.goToRoute("admin.assets.categories.index");
              },
            },
            {
              label: "Videos",
              action: () => {
                this.goToRoute("admin.videos.index");
              },
            },
            {
              label: "Video Topics",
              action: () => {
                this.goToRoute("admin.videos.topics.index");
              },
            },
          ],
        },
        {
          label: "Forms",
          items: [
            {
              label: "Registration Forms",
              action: () => {
                this.goToRoute("admin.forms.index");
              },
            },
            {
              label: "Surveys",
              action: () => {
                this.goToRoute("admin.surveys.index");
              },
            },
            {
              label: "Survey Field Groups",
              action: () => {
                this.goToRoute("admin.surveys.field-groups.index");
              },
            },
            {
              label: "Tests",
              action: () => {
                this.goToRoute("admin.tests.index");
              },
            },
            {
              label: "Question Bank",
              action: () => {
                this.goToRoute("admin.tests.question-bank");
              },
            },
          ],
        },
        {
          label: "System",
          items: [
            {
              label: "Themes",
              action: () => {
                this.goToRoute("admin.themes.index");
              },
            },
            {
              label: "Brands",
              action: () => {
                this.goToRoute("admin.brands.index");
              },
            },
            {
              label: "Categories",
              action: () => {
                this.goToRoute("admin.categories.index");
              },
            },
            {
              label: "Topics",
              action: () => {
                this.goToRoute("admin.topics.index");
              },
            },
            {
              label: "Tags",
              action: () => {
                this.goToRoute("admin.tags.index");
              },
            },
            {
              label: "Coupons",
              action: () => {
                this.goToRoute("admin.coupons.index");
              },
            },
            {
              label: "Referrals",
              action: () => {
                this.goToRoute("admin.referrals.index");
              },
            },
            {
              label: "Emails",
              action: () => {
                this.goToRoute("admin.emails.index");
              },
            },
            {
              label: "Help Articles",
              action: () => {
                this.goToRoute("admin.help.articles.index");
              },
            },
            {
              label: "Help Downloads",
              action: () => {
                this.goToRoute("admin.help.downloads.index");
              },
            },
            {
              label: "Announcements",
              action: () => {
                this.goToRoute("admin.announcements.index");
              },
            },
            {
              label: "Settings",
              action: () => {
                this.goToRoute("admin.settings.index");
              },
            },
            {
              label: "System Logs",
              action: () => {
                this.goToRoute("admin.logs.logins.index");
              },
            },
          ],
        },
      ];
    },
  },
};
</script>